import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RoleAccessLayer from "../../components/RoleAccessLayer";
import ComprobantesLayer from "../../components/comprobantes/ComprobantesLayer"

const Comprobantes = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Comprobantes" />

        {/* RoleAccessLayer */}
        <ComprobantesLayer/>

      </MasterLayout>

    </>
  );
};

export default Comprobantes; 
